import React, { useEffect } from "react";

type ButtonData = {
  id: string;
  text: string;
};

type ScrollProps = {
  data: ButtonData;
};

const scrollToFormSection = () => {
  const formSection = document.querySelector("#form-view") as HTMLElement;
  if (formSection) {
    formSection.style.scrollMargin = "150px";
    formSection.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Scroll({ data }: ScrollProps) {
  useEffect(() => {}, []);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    scrollToFormSection();
  };

  return (
    <button
      className="btn-primary lg:px-10 md:w-100"
      id={data.id}
      onClick={handleClick}
    >
      <span>{data.text}</span>
      <style jsx>{`
        button {
          border: none;
          cursor: pointer;
        }
      `}</style>
    </button>
  );
}
